import React, { Component } from "react";
import { withFirebase } from "../Firebase";
import { compose } from "recompose";
import * as ROUTES from "../../constants/route";
import {
  GOOGLE_PLAY_LISTING_URL,
  APPLE_APP_STORE_LISTING_URL,
  HUAWEI_APP_GALLERY_LISTING_URL,
} from "../../constants/storeLinks";
import { Button, Container, LinearProgress } from "@material-ui/core";
import Logo from "../../contents/img/Rampver_Online_Logo-main.png";
import googlePlayBadge from "../../assets/icons/google-play-store-badge.png";
import appStoreBadge from "../../assets/icons/apple-app-store-badge.png";
import appGalleryBadge from "../../assets/icons/huawei-appgallery-badge.png";
import axios from "axios";

const EmailVerificationPage = (props) => {
  return <EmailVerificationHandler props={props} />;
};

class EmailVerificationHandler extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "Verifying Email",
      subtitle: "Please wait a moment",
      showStoreButtons: false,
      isProcessing: true,
      showRecoveryActions: false,
      showLoginAction: false,
    };

    this.fb = props.props.firebase;
    this.location = props.props.location;
    this.history = props.props.history;

    this.actionCode = new URLSearchParams(this.location.search).get("oobCode");
    this.mode = new URLSearchParams(this.location.search).get("mode");
    this.email = new URLSearchParams(this.location.search).get("email");
  }

  componentDidMount() {
    switch (this.mode) {
      case "verifyEmail":
        this.handleVerification();
        break;

      case "resetPassword":
        this.history.push({
          pathname: `/confirm-password/${this.actionCode}`,
          state: { code: this.actionCode },
        });
        break;
      default:
        this.showVerificationFailure();
        break;
    }
  }

  handleVerification = async () => {
    if (!this.actionCode) {
      this.showInvalidLink();
      return;
    }

    try {
      await this.fb.handleVerifyEmail(this.actionCode);
    } catch (error) {
      this.showVerificationFailure(error);
      return;
    }

    try {
      const result = await axios.post(
        `${ROUTES.FUNCTION_BASE_URL}clients-client/sendWelcome`,
        JSON.stringify({ token: this.actionCode }),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!result?.data?.ok) {
        this.showWelcomeFailure();
        return;
      }
    } catch (error) {
      this.showWelcomeFailure();
      return;
    }

    this.showVerificationSuccess();
  };

  showVerificationSuccess = () => {
    this.setState({
      title: "Congratulations! Your Rampver Online email has been verified.",
      subtitle: "You can now open Rampver Online using the app links below.",
      showStoreButtons: true,
      isProcessing: false,
      showRecoveryActions: false,
      showLoginAction: false,
    });
  };

  showWelcomeFailure = () => {
    this.setState({
      title: "Your Rampver Online email has been verified.",
      subtitle:
        "Your account is ready. You can log in now. We couldn't complete the welcome email step.",
      showStoreButtons: true,
      isProcessing: false,
      showRecoveryActions: false,
      showLoginAction: true,
    });
  };

  showInvalidLink = () => {
    this.setState({
      title: "This verification link is no longer usable.",
      subtitle:
        "It may have expired or already been used. Try logging in or request a new verification email.",
      showStoreButtons: false,
      isProcessing: false,
      showRecoveryActions: true,
      showLoginAction: false,
    });
  };

  showVerificationFailure = (error) => {
    if (
      error?.code === "auth/invalid-action-code" ||
      error?.code === "auth/expired-action-code"
    ) {
      this.showInvalidLink();
      return;
    }

    this.setState({
      title: "We couldn't verify your email.",
      subtitle:
        "Please try logging in or request a new verification email.",
      showStoreButtons: false,
      isProcessing: false,
      showRecoveryActions: true,
      showLoginAction: false,
    });
  };

  handleLogin = () => {
    this.history.push(ROUTES.SIGN_IN);
  };

  handleResend = () => {
    const state = { resendPage: true };

    if (typeof this.email === "string" && this.email) {
      state.email = this.email;
    }

    this.history.push({ pathname: ROUTES.SIGN_IN, state });
  };

  render() {
    const {
      title,
      subtitle,
      showStoreButtons,
      isProcessing,
      showRecoveryActions,
      showLoginAction,
    } = this.state;

    const storeLinks = [
      {
        id: "google-play",
        url: GOOGLE_PLAY_LISTING_URL,
        src: googlePlayBadge,
        alt: "Get it on Google Play",
        ariaLabel: "Get Rampver Online on Google Play",
      },
      {
        id: "app-store",
        url: APPLE_APP_STORE_LISTING_URL,
        src: appStoreBadge,
        alt: "Download on the App Store",
        ariaLabel: "Get Rampver Online on the App Store",
      },
      {
        id: "app-gallery",
        url: HUAWEI_APP_GALLERY_LISTING_URL,
        src: appGalleryBadge,
        alt: "Explore it on AppGallery",
        ariaLabel: "Get Rampver Online on Huawei AppGallery",
      },
    ].filter((item) => Boolean(item.url));

    return (
      <>
        {isProcessing ? <LinearProgress /> : null}
        <Container>
          <div id="message" className="r-title-container text-center">
            <img src={Logo} className="email-handler-img" alt="rampver-logo" />
            <br />
            <p className="r-title" aria-live="polite" aria-atomic="true">
              {title}
            </p>
            <p className="r-subtitle">{subtitle}</p>
            {showStoreButtons && storeLinks.length > 0 ? (
              <div
                className="email-verification-store-links"
                role="group"
                aria-label="Download the mobile app"
              >
                {storeLinks.map((item) => (
                  <a
                    key={item.id}
                    className="email-verification-store-link"
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={item.ariaLabel}
                  >
                    <img
                      className="email-verification-store-badge"
                      src={item.src}
                      alt={item.alt}
                    />
                  </a>
                ))}
              </div>
            ) : null}
            {showRecoveryActions || showLoginAction ? (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "16px",
                  marginTop: "28px",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleLogin}
                >
                  Try logging in
                </Button>
                {showRecoveryActions ? (
                  <Button variant="outlined" onClick={this.handleResend}>
                    Resend verification email
                  </Button>
                ) : null}
              </div>
            ) : null}
          </div>
        </Container>
      </>
    );
  }
}

export default compose(withFirebase)(EmailVerificationPage);

export { EmailVerificationHandler };
